module.exports = __webpack_public_path__ + "media/images/payment-pushkin-9450b81058c50540262b51ceedde0226.png";